const TextEnum = {
    VERSION: "version",
    REQUESTED_ROUTE: "requestedRoute",
    USUARIO: "usuario",
    ESTADOS: "estados",
    TIPOS_PRODUCTO: "tipos_producto",
    MARCAS: "marcas",
    UNIDADES_MEDIDA: "unidades_medida",
    ALMACENES: "almacenes",
    CATEGORIAS: "categorias",
    CONDICIONES_COMERCIALES: "condiciones_comerciales",
}

export default TextEnum